import React from "react";
import './illustration.scss';

import { connect } from 'remx';
import * as store from '../../../stores/slider/store';
import * as actions from '../../../stores/slider/actions';

class IllustrationComponent extends React.Component {
    
    constructor() {
        super();
        this.state = {};
        this.component = React.createRef();
    }

    componentDidMount(){
        document.querySelector('.page-wrapper').addEventListener('scroll',this.animationScroll);
        const title = this.component.current.querySelector('.animatedTitle')?.getBoundingClientRect();
        let position = [title.left, title.top];
        this.scrollWrapper = document.querySelector('.page-wrapper');
        this.resizeListener = () => {
            this.calcPosition();
            this.showSlides();
        }
        this.calcPosition();
        this.showSlides();
        window.addEventListener('resize', this.resizeListener);

        this.scrollListener = () => {
            if(this.scrollWrapper.scrollTop > 0 && this.component.current.getBoundingClientRect().bottom > 100){
                this.component.current.querySelector('.sidebar').classList.add('animated');
                this.component.current.querySelector('.toolbar').classList.add('animated');
            } else{
                this.component.current.querySelector('.sidebar').classList.remove('animated');
                this.component.current.querySelector('.toolbar').classList.remove('animated');
            }
        }

        this.scrollWrapper.addEventListener('scroll', this.scrollListener);
    }

    changeSlide(index) {
        actions.switchActiveIndex(index);
        this.component.current.querySelectorAll('.illustration-component .tab')?.forEach((element, i) => {
            element.classList.remove('active');
            if(index === i){
                element.classList.add('active');
            }
        });
    }

    showSlides() {
        if(window.innerWidth > 768){
            this.component.current.querySelector('.sidebar .wrap').style.setProperty('--wrap-height', `${(this.component.current.querySelector('.img-wrap ').getBoundingClientRect().height * 4) + 80}px`);
        } else{
            this.component.current.querySelector('.sidebar .wrap').style.setProperty('--wrap-height', `${(this.component.current.querySelector('.img-wrap ').getBoundingClientRect().height * 3) + 35}px`);
        }
    }

    calcPosition() {
        const title = this.component.current.querySelector('.animatedTitle')?.getBoundingClientRect();
        let position = [title.left, title.top + this.scrollWrapper.scrollTop];

        store.setters.setTitlePosition(position);
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.resizeListener);
        this.scrollWrapper.removeEventListener('scroll', this.scrollListener);
    }

    render(){
        return (
            <div className="illustration-component" ref={this.component}>

                <div className="image-item-0">
                    <div className="tabs-svg">
                        <div className="tabs-circles">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        <ul>
                            {this.props.tabs.map((value, index) => 
                                <li  key={index} className={`item ${this.props.activeIndex === index ? 'active' : ''}`} onClick={() => this.changeSlide(index)}>
                                    <span style={{background : this.props.colors[index]}}></span>
                                    <p className="text-style--t2">{value}</p>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>

                <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615537961/hp2021/banners/Upper-Header_efwkzl.svg" alt="#" className="image-item-1" />
                <p className="extra-title--h2 title animatedTitle">{this.props.values[this.props.activeIndex]}</p>
                <div className="inner-content">
                    <div className={`item tab tab-1 ${this.props.activeIndex === 0 ? 'active' : ''}`}>
                        <link rel="preload" href="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615907626/hp2021/banners/tab_1/Body_3x.png" as="image"/>
                        <img rel="preload" src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615907626/hp2021/banners/tab_1/Body_3x.png" alt="#" className="image-item-1" />
                    </div>
                    <div className={`item tab tab-2 ${this.props.activeIndex === 1 ? 'active' : ''}`}>
                        <link rel="preload" href="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616139141/hp2021/banners/tab_2/Group_20610_3x.png" as="image"/>
                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616139141/hp2021/banners/tab_2/Group_20610_3x.png" alt="#" className="image-item-1" />
                    </div>
                    <div className={`item tab tab-3 ${this.props.activeIndex === 2 ? 'active' : ''}`}>
                        <link rel="preload" href="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616577036/hp2021/banners/tab_3/Group_20752_3x.png" as="image"/>
                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616577036/hp2021/banners/tab_3/Group_20752_3x.png" alt="#" className="image-item-1" />
                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615556198/hp2021/banners/tab_3/main_image_ppt_file.svg" alt="#" className="image-item-2" />
                    </div>
                    <div className={`item tab tab-4 ${this.props.activeIndex === 3 ? 'active' : ''}`}>
                        <link rel="preload" href="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615567668/hp2021/banners/tab_4/main_image_3x.png" as="image"/>
                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615567668/hp2021/banners/tab_4/main_image_3x.png" alt="#" className="image-item-1" />
                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615567668/hp2021/banners/tab_4/screen_recordings_webcam_circle_3x.png" alt="#" className="image-item-2" />
                    </div>
                    <div className={`item tab tab-5 ${this.props.activeIndex === 4 ? 'active' : ''}`}>
                        <link rel="preload" href="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615907866/hp2021/banners/tab_5/Body_3x.png" as="image"/>
                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615907866/hp2021/banners/tab_5/Body_3x.png" alt="#" className="image-item-1" />
                    </div>
                    <div className={`item tab tab-6 ${this.props.activeIndex === 5 ? 'active' : ''}`}>
                        <link rel="preload" href="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615908119/hp2021/banners/tab_6/Body_3x.png" as="image"/>
                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615908119/hp2021/banners/tab_6/Body_3x.png" alt="#" className="image-item-1" />
                    </div>
                    <div className={`item tab tab-7 ${this.props.activeIndex === 6 ? 'active' : ''}`}>
                        <link rel="preload" href="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615568865/hp2021/banners/tab_7/Group_4444444_3x.png" as="image"/>
                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615568865/hp2021/banners/tab_7/Group_4444444_3x.png" alt="#" className="image-item-1" />
                    </div>
                    <div className={`item tab tab-8 ${this.props.activeIndex === 7 ? 'active' : ''}`}>
                        <link rel="preload" href="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616575478/hp2021/banners/tab_8/Group_20090_3x.png" as="image"/>
                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616575478/hp2021/banners/tab_8/Group_20090_3x.png" alt="#" className="image-item-1" />
                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615568509/hp2021/banners/tab_8/gifs_dropdown_3x.png" alt="#" className="image-item-2" />
                    </div>
                </div>
                <div className="toolbar image-item-3">
                    <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616140722/hp2021/banners/00_sidebar_with_icons_3x.png" alt="#" />
                </div>

                <div className={`image-item-4 sidebar`}>
                    <div className="top-wrap text-style--t2">
                        Slide <span>{this.props.activeIndex + 1}</span> of {this.props.values.length}
                    </div>
                    <div className="wrap">
                        {this.props.previews[this.props.activeIndex].map((value, index) => 
                            <div key={index} className={`img-wrap ${index === 0 ? 'active' : ''}`}>
                                <img src={value} alt="#"/>
                            </div>
                        )}
                    </div>
                    <div className="add-wrap">
                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542616/hp2021/general/Plus.svg" alt="#" />
                        <span className="text-style--t2">Blank slide</span>
                    </div>
                </div>
                
                <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615553299/hp2021/banners/timeline.svg" alt="#" className="image-item-5" />
            </div>
        );
    }
}
function mapStateToProps() {
    return {
        activeIndex: store.getters.getActiveIndex(),
        values: store.getters.getValues(),
        tabs: store.getters.getTabs(),
        colors: store.getters.getColors(),
        previews: store.getters.getPreviews()
    };
}

export default connect(mapStateToProps)(IllustrationComponent);